import { type Purchase } from '@icare/types';

import { type Locale } from '../../store/i18nSlice';

export enum QuickSearchType {
  phone = 'phone',
  cardNumber = 'card_number',
  email = 'email',
}

export enum CustomerFormType {
  create = 'create',
  update = 'update',
}

export enum CustomerType {
  customer = 'customer',
  internal = 'internal',
}

export interface CustomerInput {
  lastname?: string;
  firstname?: string;
  companyName?: string;
  personType?: PersonTypes;
  companyType?: CompanyType;
  email?: string;
  phone?: string;
  cardNumber?: string;
  addressLine1?: string;
  addressLine2?: string;
  postalCode?: string;
  city?: string;
  countryCode?: string;
  gender?: number;
  optIn?: boolean;
  quickSearchType?: QuickSearchType;
}

export interface CustomerAddress {
  addressLine1?: string;
  addressLine2?: string;
  postalCode?: string;
  city?: string;
  countryCode?: string;
}

export interface CustomerIdentity {
  lastname: string;
  firstname: string;
  gender?: number;
  personType: PersonTypes;
  companyName?: string;
  companyType?: CompanyType;
}

export interface Customer extends CustomerIdentity, CustomerAddress {
  email?: string;
  idPerson?: string;
  memberId: string;
  oldMemberId?: string;
  phone?: string;
  purchases?: Purchase[];
  smsAlert?: boolean;
  emailAlert?: boolean;
  language?: Language | null;
  yearOfBirth?: string;
  isUnauthorized?: boolean;
}

export interface UnauthorizedCustomer {
  isUnauthorized: boolean;
  personType: PersonTypes;
}

export interface Language extends Locale {
  default?: boolean;
}

export enum Gender {
  man = 1,
  woman = 2,
}

export enum PersonTypes {
  customer = 1,
  company = 2,
  decathlon = 3,
}

export enum CompanyType {
  sportClub = 2,
  administration = 5,
  business = 6,
  association = 21,
  other = 22,
  school = 27,
}

export interface CustomersLightDetails {
  memberId?: string;
  customerName: string;
  phone?: string;
}

export const companyTypes = Object.keys(CompanyType).filter(key => Number.isNaN(Number(key)));
